#### Updates for GraphQL over HTTP compatibility

On the 23rd March 2024, we will be making changes to the SEEK API to ensure compliance with the [GraphQL over HTTP specification]:

- Previously, response bodies contained an `Content-Type: application/json` header.
  This will be changed to `Content-Type: application/json; charset=utf-8`, as [recommended][spec-body] by the specification.
  The encoding of the body is not changing, and will continue to be UTF-8.
  We advise your software not to take hard dependencies on the exact format of the `Content-Type` response header, as it may change in the future.
  For example, `application/graphql-response+json; charset=utf-8` may be used in the future.
  We advise you to check that your software is resilient to changes in the `Content-Type` response header before the 23rd March 2024.

- Previously, the SEEK API accepted non-standard request bodies containing `variables` as a JSON-stringified object.
  This may look like `{"query": "...", "variables": "{...}"}`.
  This support will be removed, as it is not supported by [the specification][spec-post].
  We require your software to use the standard request body format.
  This may look like `{"query": "...", "variables": {...}}`.
  We advise you to check that your software is not using this non-standard request format before the 23rd March 2024.

[GraphQL over HTTP specification]: https://graphql.github.io/graphql-over-http/draft/
[spec-body]: https://graphql.github.io/graphql-over-http/draft/#sec-Body
[spec-post]: https://graphql.github.io/graphql-over-http/draft/#sec-POST
